
import {Component} from 'vue-property-decorator';
import FaBoxComponent from '@/Components/FaBoxComponent.vue'

@Component({})
class FaCheckboxComponent extends FaBoxComponent {
    static COMPONENT_NAME = 'fa-checkbox-component';

    box: string = 'square';

    protected isChecked(): boolean {
        if (Array.isArray(this.context.model)) {
            return this.context.model.includes(this.context.value);
        }

        return super.isChecked();
    }
}

export default FaCheckboxComponent;
